import { render, staticRenderFns } from "./BeautyDataSheet.vue?vue&type=template&id=8ea9c47c"
import script from "./BeautyDataSheet.vue?vue&type=script&lang=js"
export * from "./BeautyDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BeautyDataSheet.vue?vue&type=style&index=0&id=8ea9c47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports